import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { AppState } from 'src/app/store/app.state';
import * as fromAuthAction from '../../../../store/actions/auth.actions';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { setLoadingSpinner } from 'src/app/store/actions/shared.action';
import { MatDatepicker } from '@angular/material/datepicker';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  form: FormGroup;
  hidePassword = true;

  ngUnsubscribe = new Subject<void>();

  emailPattern = /^([a-z0-9_\.\+-]+)@([\da-z\.-]+)\.([a-z\.]{2,6})$/;

  monthYearControl = new FormControl();
  startDate = new Date();

  selectedYear!: number;

  max = new Date();
  
  constructor(
    private fb: FormBuilder,
    private store: Store<AppState>,
    private router: Router,
    private authService: AuthService,
  ) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      username: ['', [Validators.required]],
      password: ['', [Validators.required]],
    });
  }

  login() {
    const payload = {
      username: this.username?.value,
      password: this.password?.value
    };
    this.store.dispatch(setLoadingSpinner({status: true}));
    this.store.dispatch(fromAuthAction.login({data: payload}));
  }

  register() {
    this.router.navigateByUrl('/auth/register');
  }

  forgotPassword() {
    this.router.navigateByUrl('/auth/forgot-password');
  }

  get username() {
    return this.form.get('username');
  }

  get password() {
    return this.form.get('password');
  }

  chosenYearHandler(normalizedYear: Date) {
    this.selectedYear = normalizedYear.getFullYear();
  }

  chosenMonthHandler(normalizedMonth: Date, datepicker: MatDatepicker<Date>) {
    const ctrlValue = new Date();
    ctrlValue.setFullYear(this.selectedYear);
    ctrlValue.setMonth(normalizedMonth.getMonth());
    this.monthYearControl.setValue(ctrlValue);
    datepicker.close();
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}